<template>
  <div>

    <div id="div1"></div>
  </div>
</template>
<script>
import E from 'wangeditor';
import * as news from '@/api/public.js';
export default {
  props: ['catchData', 'isClear'],
  data() {
    return {
      editorData: '',
      editor: '',
    };
  },
  computed: {
    headers() {
      return {
        Authorization: 'Bearer ' + this.$store.getters.tokens,
      };
    },
  },
  created() {},
  watch: {
    isClear(val) {
      // console.log(val)
      if (val) {
        this.editor.txt.clear();
      }
    },
  },
  mounted() {
    // console.log(this.catchData)

    this.initializeeditor();
    this.editor.txt.html(this.catchData);
  },
  methods: {
    abc(catchData) {
      if (catchData != null) {
        this.editor.txt.html(catchData);
      }
    },
    // 富文本插件初始化
    initializeeditor() {
      let _this = this;
      this.editor = new E('#div1');
      this.editor.config.zIndex = 200;
      this.editor.config.height = 500;
      //上传视频文件的接口
      this.editor.config.uploadVideoServer = '/resource/File/UploadFile';
      //关闭粘贴样式的过滤
      this.editor.config.pasteFilterStyle = false;

      // 配置 onchange 回调函数，将数据同步到 vue 中
      this.editor.config.onchange = (newHtml) => {
        this.editorData = newHtml;
        // console.log(this.editorData);
        // this.$emit('change', this.editorData)
      };

      //上传本地图片
      this.editor.config.customUploadImg = function (files, insert) {
        // files 是 input 中选中的文件列表
        // insert 是获取图片 url 后，插入到编辑器的方法
        files.forEach((item) => {
          let fd = new FormData();
          fd.append('file', item); // 上传的文件： 键名，键值
          //   console.log(fd);
          // 以下是上传图片的接口，视情况而更改就可以啦
          news.uploadDoc(fd).then((res) => {
            // console.log(res);
            if (res.message == '操作成功') {
              //   console.log(res);
              insert(res.result);
            }
          });
        });
      };
      //        上传本地视频
      this.editor.config.uploadVideoHooks = {
        // 上传视频之前
        before: function (xhr) {
          console.log(xhr); // 可阻止视频上传 // return { //   prevent: true, //   msg: '需要提示给用户的错误信息', // };
        }, // 视频上传并返回了结果，视频插入已成功
        success: function (xhr) {
          console.log('success', xhr);
        }, // 视频上传并返回了结果，但视频插入时出错了
        fail: function (xhr, editor, resData) {
          console.log('fail', resData);
        }, // 上传视频出错，一般为 http 请求的错误
        error: function (xhr, editor, resData) {
          console.log('error', xhr, resData);
        }, // 上传视频超时
        timeout: function (xhr) {
          console.log('timeout');
        }, // 视频上传并返回了结果，想要自己把视频插入到编辑器中 // 例如服务器端返回的不是 { errno: 0, data: { url : '.....'} } 这种格式，可使用 customInsert
        customInsert: function (insertVideoFn, result) {
          // result 即服务端返回的接口
          console.log('customInsert', result); // insertVideoFn 可把视频插入到编辑器，传入视频 src ，执行函数即可
          insertVideoFn(result.result);
        },
      };

      //删除部分菜单
      this.editor.config.excludeMenus = [
        'code',
        'emoticon',
        // 'quote',
        // 'table',
      ];
      this.editor.create();
      // console.log(this.editor.txt.html())
      this.editor.txt.html(this.catchData); //给编辑器赋值
    },
    handleSuccess(res, file, fileList) {
      let iframe = res.result;
      let filename = file.name;
      console.log(res, file, fileList);
      this.editor.txt.append(
        "<p><div>附件:</div><a  style='color:blue' href='" +
          iframe +
          "'>'" +
          filename +
          "'</a></p>"
      );
      console.log(iframe);
    },
  },
};
</script>
<style scoped>
table {
  border-top: 1px solid #ccc;
  border-left: 1px solid #ccc;
}
table td,
table th {
  border-bottom: 1px solid #ccc;
  border-right: 1px solid #ccc;
  padding: 3px 5px;
}
table th {
  border-bottom: 2px solid #ccc;
  text-align: center;
}
</style>